module.exports = __webpack_public_path__ + "first-50-ir.jpg?f9083b7a809788d685decf867775e09c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-50-ir.jpg
// module id = 528
// module chunks = 0